import http from "./http.js";

export default {
  userGet(payload) {
    const id = payload.id ?? "";
    return http.get(`/userget/${payload.action}/${id}`);
  },
  userPost(payload) {
    return http.post("/userpost", { payload });
  },
  userUpload(files) {
    return http.post("/userupload", files, {
      headers: {
        "Content-Type": `multipart/form-data; boundary=${files._boundary}`,
      },
    });
  },

  // ---------- Termin (öffentlich) ----------
  terminGet(payload) {
    const id = payload.id ?? "";
    return http.get(`/termin/get/${payload.action}/${id}`);
  },
  terminPost(payload) {
    return http.post("/termin/post", { payload });
  },

  // ---------- Termin (Admin) ----------
  terminAdminGet(payload) {
    const id = payload.id ?? "";
    const qs = payload.query
      ? "?" + new URLSearchParams(payload.query).toString()
      : "";
    return http.get(`/admin/termin/get/${payload.action}/${id}${qs}`);
  },
  terminAdminPost(payload) {
    return http.post("/admin/termin/post", { payload });
  },
};
